import styled from "styled-components";
import { pxToRem } from "../../styles/utils";


export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: radial-gradient(
      51% 51% at 50% 121%,
      ${({ theme }) => theme.colors.brandLight},
      ${({ theme }) => theme.colors.brandTransparent}
    ),
    ${({ theme }) => theme.colors.canvas};
`;

export const Content = styled.div`
  max-width: ${pxToRem(600)};
  padding: ${pxToRem(20)};
`;

export const ErrorCode = styled.h1`
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(290)};
  font-weight: 600;
  line-height: 1;
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(48)};
  font-weight: 600;
  margin-bottom: ${pxToRem(43)};
`;

export const HomeLink = styled.a`
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brand};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  padding: ${pxToRem(16)} ${pxToRem(28)};
  color: ${({ theme }) => theme.colors.brand};
  text-decoration: none;
  font-size: ${pxToRem(16)};
  font-weight: 600;

  &:hover {
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    background: ${({ theme }) => theme.colors.brandPale};
    color: ${({ theme }) => theme.colors.white};
  }
`;
